"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CertifiedIDRequest = void 0;
var CertifiedIDRequest = /** @class */ (function () {
    function CertifiedIDRequest() {
    }
    return CertifiedIDRequest;
}());
exports.CertifiedIDRequest = CertifiedIDRequest;
;
//# sourceMappingURL=certifiedID.request.js.map